import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import { notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import { updateInvoiceName } from "../../../controllers/V1/customerDue/dueController";

const UpdateInvoiceName = ({ popUpOpen, togglePopUp, edit_data, setEditData }) => {
  const [errors, setErrors] = useState({});

  const handleCancel = () => {
    togglePopUp();
    setEditData('');
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrors({});
      const form = new FormData(e.target);
      const invoice_name = form.get('invoice_name')?.trim();

      if (!edit_data?._id) {
        notification.open({
          message: "Oops!",
          description: "User not found! Please try again.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
        return;
      }

      if (!invoice_name) {
        notification.open({
          message: "Oops!",
          description: "Invoice name is required.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
        return;
      }

      const res = await updateInvoiceName({
        users_id: edit_data._id,
        invoice_name,
      });

      if (res.status === true) {
        notification.open({
          message: "Success",
          description: "Invoice name updated successfully.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
          duration: 2,
        });
        handleCancel();
      } else {
        notification.open({
          message: "Oops!",
          description: res?.message || "Failed to update invoice name.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"sm"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Update Invoice Name
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form className="categories_open_popup_form" onSubmit={handleSubmit}>
                <input type="hidden" name="user_id" value={edit_data?._id} />
                <div className="form-group row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label htmlFor="invoice_name" className="all_lable_for_vendor_dashbaord">
                      <span style={{ color: "red" }}>*</span> Invoice Name
                    </label>
                    <input
                      type="text"
                      name="invoice_name"
                      id="invoice_name"
                      className="form-control categories_select_tg_enter_product"
                      placeholder="Enter invoice name"
                      defaultValue={edit_data?.invoice_name || ''}
                    />
                    {errors?.invoice_name && <span className="text-danger">{errors.invoice_name}</span>}
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-danger">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
      </div>
    </Dialog>
  );
};

export default UpdateInvoiceName;
